import React from 'react';
import styled from 'styled-components';

const Svg = styled.svg``;

type UnsavedBoardIconProps = {
  as?: React.ElementType;
  width?: number;
  height?: number;
  color?: string;
};

export const UnsavedBoardIcon = ({
  as,
  width = 12,
  height = 16,
  color = '#000',
}: UnsavedBoardIconProps) => (
  <Svg
    as={as}
    width={width}
    height={height}
    viewBox="0 0 16 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m8 11.529 5.333 4.444V3H2.667v12.973L8 11.53ZM0 21.667V.333h16v21.334L8 15l-8 6.667Z"
      fill={color}
    />
  </Svg>
);
